import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Route } from "react-router-dom";
import AnalyticsService from "./services/analytics.service";
import { getDeviceType, getDeviceId } from "utils/helper";
import { LocalStorageUtils } from "utils/localstorage.utils";
import { PostHogProvider } from "posthog-js/react";

AnalyticsService.init();
AnalyticsService.setTag("deviceType", getDeviceType());
AnalyticsService.setTag("deviceId", getDeviceId());
AnalyticsService.setTag("areaId", LocalStorageUtils.getAreaId());

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
        debug: process.env.NODE_ENV === "development",
      }}
    >
      <Route>
        <App />
      </Route>
    </PostHogProvider>
  </React.StrictMode>
);
